import useApp from "./useApp";
import router from "@/router";
import { onMounted } from "vue";

const passwordChange = () => {
    const { axiosBase, validEmail, host, ToastMsgSuccess, ToastMsgError, ToastMsgWarning, ToastMsgInfo, getQueryParam, showPassword } = useApp()
    let data = {
        errors: [],
        user: {
            newPassword: "",
            confirmPassword: "",
            token: ""
        }
    }

    onMounted(() => {
        if (window.location.search != "") {
            data.user.token = decodeURIComponent(getQueryParam("token"));
        } else {
            ToastMsgError("Error! No Autorizado!", "user", 3000)
        }

    })

    const change_password = () => {
        
        const axiosHeader = {
            headers: {
                token:  data.user.token
            }
        }
        axiosBase
            .post("/change-password", data.user, axiosHeader)
            .then(res => {

                //success! - Usuario creado.
                if (res.data.status == "success") {
                    ToastMsgSuccess("Tu Contraseña Se ha Cambiado Con Exito", "user-lock", 5000)
                    router.push('/login');
                    return;
                }

            })
            .catch(e => {

                if (e.response == undefined) {
                    ToastMsgError("Error Api Server !", "server", 5000)
                    return
                } else if (e.response.status == 401) {
                    ToastMsgWarning("No Autorizado !", "frown", 5000)
                    router.push("/login")
                    return
                } else if (e.response.data.status == "error") {
                    ToastMsgWarning(e.response.data.error, "server", 5000)
                    return
                }
                ToastMsgEror("Error ! Undefined", "server", 5000)
                return
            });


    }


    const check_form = () => {
        data.errors = [];
        if (data.user.newPassword == "" || data.user.confirmPassword == "") {
            data.errors.push("Completar Todos los campos")
        } else if (data.user.newPassword != data.user.confirmPassword) {
            data.errors.push("Las Contraseñas No Coinciden !")
        } else if (data.user.newPassword.length < 6) {
            data.errors.push("Contraseña Debil ! debe ser mayor a 6 digitos")
        } else if (data.user.token == "") {
            data.errors.push("Error Token Not Found !")
        }

        if (data.errors.length == 0) {
            change_password()
        }

        data.errors.map((msg) => {
            ToastMsgInfo(msg, "user", 5000)
        })

    }

    return {
        check_form,
        data,
        showPassword
    }
}


export default passwordChange